import { CONTRACT_COMPONENT_TYPE_ENUM } from "@/static/contractComponentTypes";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";

export class ContractComponentViewModel {
  @IsString()
  @Expose()
  tmpId!: string;
  @IsEnum(CONTRACT_COMPONENT_TYPE_ENUM)
  @Expose()
  type!: CONTRACT_COMPONENT_TYPE_ENUM;
  @IsString()
  @IsOptional()
  @Expose()
  description!: string;
  @IsString()
  @IsOptional()
  @Expose()
  from!: string | null;
  @IsString()
  @IsOptional()
  @Expose()
  to!: string | null;
  @IsBoolean()
  @Expose()
  isPairToCostDocument!: boolean;
  @IsBoolean()
  @Expose()
  hasFile!: boolean;
}

export class ContractComponentViewModelResponse extends GenericTableResponse<ContractComponentViewModel> {
  @Type(() => ContractComponentViewModel)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ContractComponentViewModel>;
}
